<template>
    <header class="service masthead d-flex align-items-center border-bottom" :class="className" v-animate="'fade-in'">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="img-area"><img :src="image" :alt="category" width="269"/></div>
                    <span class="d-flex service-label">
                        <span class="animation-block" :class="{'is-active': started}">
                            <span class="animation-block-inner">
                                <span class="animation-block-text bg-dark text-white" v-html="category"></span>
                            </span>
                        </span>
                    </span>
                    <h1 v-html="title"></h1>
                </div>
                <div class="col-lg-5 d-flex justify-content-end">
                    <ol class="service-list">
                        <li v-for="service in services" :key="service.id" :class="{ active: service.id == activeService }">
                            <span v-if="service.id == activeService" class="service-text" key="active_service">{{ service.name }}</span>
                            <a :href="service.link" v-else key="normal_service"><span class="service-text">{{ service.name }}</span></a>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'Masthead',
        props: {
            activeService: Number,
            title: String,
            category: String,
            image: String,
            className: String,
        },
        data () {
            return {
                started: false,
                services: [
                    { id: 1, name: "海外SNS運用サービス", link: '/global/service/global-sns', },
                    { id: 2, name: "EC支援サービス", link: '/global/service/global-e-commerce' },
                    { id: 3, name: "広告配信", link: '/global/service/global-ad' },
                    { id: 4, name: "海外プロモーション", link: '/global/service/inbound' },
                    { id: 5, name: "Webサイト", link: '/global/service/website-development' },
                ]
            }
        },
        mounted() {
            this.started = true;
        }
    }
</script>

<style lang="scss" scoped>
    .animation-block-inner {
        transform: translateX(-100.5%);
        transform-origin: left center;
        transition: transform 0.5s cubic-bezier(0.895, 0.03, 0.685, 0.22) 0.5s;
    }

    .animation-block, .animation-block-inner {
        position: relative;
        display: block;
        overflow: hidden;
    }

    .animation-block.is-active .animation-block-inner {
        transform: translateX(0);

        &:after {
            transform: translateX(100.5%);
        }
    }

    .animation-block-inner:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #FFBC07;
        transform-origin: right;
        transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1) 1.6s;
    }

    .animation-block-text {
        padding: 0 33px;
        display: block;
    }

    header.masthead {
        position: relative;
        height: 100vh;
        min-height: 916px;
        border-bottom: 1px;
        .img-area {
            margin-bottom: 55px;
        }
        h1 {
            font-size: 64px;
            letter-spacing: 0px;
            line-height: 84px;
            vertical-align: unset;
            margin-top: 35px;
        }

        span {
            font-size: 28px;
            letter-spacing: 1.4px;
            line-height: 50px;
        }

        .service-label {
            font-weight: 700;
        }

        .service-list {
            span {
                display: inline-block;
                padding: 5px 32px;
            }
        }

    }
    ol.service-list {
        counter-reset: item;
        list-style-type: none;
        font-size: 28px;
        letter-spacing: 1.12px;
        line-height: 90px;
        font-weight: bold;
        color: #DDDDDD;
        >li {
            display: block;
            &:before {
                content: counter(item, decimal-leading-zero) "/";
                counter-increment: item;
                font-size: 16px;
                width: 100px;
            }
            &:not(.active) {
                &:hover {
                    color: #000000;
                    a {
                        color: #000000;
                    }
                    span {
                        &:after {
                            width: 71px;
                        }
                    }
                }
            }
            span {
                position: relative;
                &:after {
                    position: absolute;
                    content: "";
                    display: block;
                    width: 0;
                    height: 13px;
                    top: 30%;
                    left: 100%;
                    background: url(../../assets/icons/arrow-right-dark.svg) no-repeat right center;
                    -webkit-transition: width 0.2s;
                    -moz-transition: width 0.2s;
                    -o-transition: width 0.2s;
                    -ms-transition: width 0.2s;
                    transition: width 0.2s;
                }
            }
        }
        >li.active {
            color: #000000;
        }
    }

    @media screen and (max-width: 1200px) {
        header.masthead {
            span {
                &.service-text {
                    padding: 5px 8px;
                }
            }
        }
    }

    @media screen and (max-width: 1024px) {
        header.masthead {
            span {
                font-size: 25px;
            }
        }
    }

    @media screen and (max-width: 991px) {
        .animation-block-text {
            max-width: 100%;
            display: block;
            padding: 0 40px;
        }
        header.masthead {
            text-align: center;
            height: auto;
            min-height: 100vh;
            .img-area {
                margin-top: 0;
                display: flex;
                justify-content: center;
                margin-bottom: 35px;
                img {
                    width: 57vw !important;
                }
            }
            h1 {
                font-size:40px;
                line-height: 1.3;
            }
            span {
                font-size:19px;
                letter-spacing: 0.95px;
                line-height: 43px;
                max-width: 100%;

            }
            .service-label {
                justify-content: center;
            }
        }
        ol.service-list {
            display: none;
        }
    }

    @media screen and (max-width: 767px) {
        header.masthead {
            .img-area {
                margin-bottom: 40px;
            }
            h1 {
                margin-top: 20px;
            }
        }
    }

    @media screen and (max-width: 414px) {
        header.masthead {
            .container {
                padding-right: var(--bs-gutter-x,.75rem);
                padding-left: var(--bs-gutter-x,.75rem);
            }
            h1 {
                font-size: 8.4vw;
            }
        }
        .global-sns {
            header.masthead {
                h1 {
                    font-size: 7.5vw;
                }
            }
        }
        .global-web {
            header.masthead {
                h1 {
                    font-size: 7.5vw;
                }
            }
        }
    }

</style>
